"use strict";

var _taggedTemplateLiteral = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var ButtonContainer = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 15px;\n"])));
var PageButton = styled_components_1.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: none;\n  background: none;\n  width: 15px;\n  height: 15px;\n  background-color: ", ";\n  border-radius: 50%;\n  margin-right: 25px;\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n\n  ", "\n"])), function (_ref) {
  var inactiveDotColor = _ref.inactiveDotColor;
  return inactiveDotColor;
}, function (_ref2) {
  var active = _ref2.active,
      dotColor = _ref2.dotColor;
  return active && "\n    background-color: ".concat(dotColor, "\n  ");
});

var CarouselDots = function CarouselDots(_ref3) {
  var pages = _ref3.pages,
      activeIndex = _ref3.activeIndex,
      _onClick = _ref3.onClick,
      dotColor = _ref3.dotColor,
      inactiveDotColor = _ref3.inactiveDotColor;
  return react_1.default.createElement(ButtonContainer, null, pages.map(function (_, index) {
    return react_1.default.createElement(PageButton, Object.assign({
      key: index,
      active: index === activeIndex,
      onClick: function onClick(e) {
        return _onClick(e, index);
      }
    }, {
      dotColor: dotColor,
      inactiveDotColor: inactiveDotColor
    }));
  }));
};

exports.default = CarouselDots;